import { el, btn } from '@/ui/dom';

/**
 * PauseScreen.ts — the in-race pause overlay (Escape / P / Start / the HUD
 * pause button). The world keeps rendering, dimmed, behind it.
 */
export interface PauseCallbacks {
  onResume: () => void;
  onRestart: () => void;
  onSettings: () => void;
  onQuit: () => void;
}

export class PauseScreen {
  private root: HTMLDivElement;
  private restartBtn: HTMLButtonElement;

  constructor(parent: HTMLElement, cb: PauseCallbacks) {
    this.root = el('div', 'screen screen-pause', parent);
    this.root.style.display = 'none';

    // M92: the editorial header language (gold rule-flanked kicker + chrome
    // logotype) — the pause overlay now matches the home-screen aesthetic.
    const panel = el('div', 'panel pause-panel', this.root);
    const head = el('div', 'mhead', panel);
    const kicker = el('div', 'mhead-kicker', head);
    el('span', 'mhead-rule', kicker);
    el('span', 'mhead-kicker-text', kicker).textContent = 'PIT STOP';
    el('span', 'mhead-rule', kicker);
    const logotype = el('div', 'mhead-logotype', head);
    logotype.innerHTML = '<span class="mhead-chrome">PAUSED</span>';

    const buttons = el('div', 'results-buttons', panel);
    btn('RESUME', 'btn btn-primary', buttons, cb.onResume);
    this.restartBtn = btn('RESTART RACE', 'btn btn-secondary', buttons, cb.onRestart);
    btn('SETTINGS', 'btn btn-secondary', buttons, cb.onSettings);
    // Quitting abandons the live race — the quiet destructive red (M92 rule).
    btn('QUIT TO MENU', 'btn btn-danger-ghost', buttons, cb.onQuit);
  }

  /** Online, the SERVER owns the race — a local "restart" is meaningless (it
   *  would rebuild a countdown over a live server race), so the button hides. */
  setOnline(online: boolean): void {
    this.restartBtn.style.display = online ? 'none' : '';
  }

  show(): void {
    this.root.style.display = '';
  }

  hide(): void {
    this.root.style.display = 'none';
  }

  get visible(): boolean {
    return this.root.style.display !== 'none';
  }

  dispose(): void {
    this.root.remove();
  }
}
